export default function uppercase (input) {
    console.log(input)
    return input[0].toUpperCase() + input.substr(1)
}
